import { Chain } from "database";

export const Beta_Chains: Chain[] = [
    Chain.SEPOLIA,
    Chain.MOONRIVER,
    Chain.COSMOS,
    Chain.APTOS,
    Chain.CASPER,
    Chain.PROVENANCE,
    Chain.OSMOSIS,
    Chain.INJECTIVE,
    Chain.BASE,
];
